import $ from "jquery";

const navigation = () => {
  const init = () => {
    menu();
  };

  //   const menu = () => {
  //     const el = {
  //       toggle: ".js-Nav__Toggle",
  //       navWrapper: ".page-template",
  //     }

  //     if ($(el.toggle || el.navWrapper).length === 0) return

  //     const handleToggle = (event) => {
  //       event.preventDefault()
  //       $(el.toggle).toggleClass("IsToggled")
  //       $(el.navWrapper).toggleClass("IsOpened")
  //     }
  //     if (window.innerWidth < 576) {
  //       const handleBodyClick = (event) => {
  //         if (
  //           !$(event.target).closest(el.toggle).length ||
  //           !$(event.target).closest(el.navWrapper).length
  //         ) {
  //           $(el.toggle).removeClass("IsToggled")
  //           $(el.navWrapper).removeClass("IsOpened")
  //         }
  //       }

  //       $(document.body).on("click", handleBodyClick)
  //     } else {
  //       $(document.body).off("click")
  //     }
  //     $(el.toggle).on("click", handleToggle)
  //   }

  const menu = () => {
    const el = {
      toggle: ".js-Nav__Toggle",
      navWrapper: ".page-template",
    };

    if ($(el.toggle || el.navWrapper).length === 0) return;

    const handleToggle = (event) => {
      event.preventDefault();
      $(el.toggle).toggleClass("IsToggled");
      $(el.navWrapper).toggleClass("IsOpened");
    };

    let isDesktop = window.innerWidth >= 570;

    const handleBodyClick = (event) => {
      if (!isDesktop) return;
      if (
        !$(event.target).closest(el.toggle).length ||
        !$(event.target).closest(el.navWrapper).length
      ) {
        $(el.toggle).removeClass("IsToggled");
        $(el.navWrapper).removeClass("IsOpened");
      }
    };

    if (isDesktop) {
      $(document.body).on("click", handleBodyClick);
    }

    // $(el.toggle).on("click", handleToggle);

    $(window).on("resize", () => {
      isDesktop = window.innerWidth >= 570;

      if (isDesktop) {
        $(document.body).on("click", handleBodyClick);
      } else {
        $(document.body).off("click", handleBodyClick);
        $(el.toggle).removeClass("IsToggled");
        $(el.navWrapper).removeClass("IsOpened");
      }
    });
  };
  init();
};

navigation();
